import { getSvg } from "@/utils";
import classNames from "classnames";
import { updatingAtom } from "@/atoms/app";
export default function Updating() {
  const { updating, showUpdating } = useAtomValue(updatingAtom);
  const { $t } = useTranslate();
  return (
    <div
      className={classNames([
        "center text-12 color-[var(--app-text-02)] gap-x-10 transition-[height] duration-300 ease-in-out",
        showUpdating ? "h-20 mt-10 mb-10" : "mt-0 mb-0",
      ])}
      style={{
        height: "10px",
      }}
    >
      {showUpdating && (
        <img
          className={classNames(["translate-y-[-2px]", updating ? "w-26" : "w-24"])}
          src={getSvg(updating ? "svg10.svg" : "svg06.svg")}
          alt=""
        />
      )}
      {showUpdating && <i className="font-400 text-12">{updating ? $t("title57") : $t("title58")}</i>}
    </div>
  );
}
